import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { reduxForm, Field } from "redux-form";
import { Form, Button, Grid, Header, Message } from "semantic-ui-react";
import { TextInput } from "../templates/utils/form-fields";
import { ApiRequest } from "../firebase/server";
import { fetchSkuSearch, clearSkuSearch, fetchProductImage } from "../actions";
import allStores from "../data/all-stores";

const getLocationUuid = (id) => {
  const store = allStores.find((obj) => {
    return obj.id === id;
  });
  return store.uuid;
};

let SearchForm = ({ submitting, handleSubmit }) => {
  const dispatch = useDispatch();

  const [searchResults, setSearchResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchMessage, setSearchMessage] = useState({ visible: false });

  useEffect(() => {
    if (searchResults) {
      const { tpnb, query, results } = searchResults;
      dispatch(
        fetchSkuSearch({
          tpnb,
          query,
          results,
        })
      );
    }
  }, [searchResults, dispatch]);

  const handleDismiss = () => {
    setSearchMessage({ visible: false });
  };

  const handleSubmitForm = (values) => {
    values.locationUuid = values.id
      ? getLocationUuid(values.id)
      : "478c0609-2eae-4869-9881-26b7202130a7";
    setSearchMessage({ visible: false });
    dispatch(clearSkuSearch());
    dispatch(fetchProductImage(null));
    setLoading(true);
    const arr = values.query.split(",");
    let cycle = new Promise((resolve, reject) => {
      arr.forEach((q, index) => {
        q = q.trimStart();
        q = q.trimEnd();
        const qToSet = q;
        q = q.replace(/\s+/g, "%20");
        ApiRequest({
          ...values,
          query: q,
          retailer: "tesco",
          service: "searchTesco",
        })
          .then((data) => {
            const obj = data.result.uk.ghs.products;
            obj.tpnb = values.tpnb;
            obj.query = qToSet;
            return obj;
          })
          .then((data) => {
            setSearchResults(data);
            if (index === arr.length - 1) resolve();
          })
          .catch((error) => {
            console.log("error", error);
            setLoading(false);
          });
      });
    });
    cycle.then(() => {
      ApiRequest({
        tpnb: values.tpnb,
        country: "GB",
        retailer: "tesco",
        service: "getProduct",
      })
        .then((result) => {
          if (result.result.missingSet.length) {
            setSearchMessage({
              header: "Possible error",
              content: "Please check you entered a valid TPNB",
              visible: true,
              color: "red",
            });
          } else {
            if (result.result.products[0].digitalContent) {
              dispatch(
                fetchProductImage(
                  `${result.result.products[0].digitalContent[0].url}?w=100`
                )
              );
            }
            if (result.result.products[0].hfssProgram) {
              const { hfssProgram } = result.result.products[0];
              setSearchMessage({
                header: "HFSS info",
                content: JSON.stringify(hfssProgram),
                color: hfssProgram.indicator === "HFSS" ? "red" : "green",
                visible: true,
              });
            }
          }
          setLoading(false);
        })
        .catch((error) => {
          setSearchMessage({
            header: "Error",
            content: error.message,
            visible: true,
            color: "red",
          });
          setLoading(false);
        });
      setLoading(false);
    });
  };
  return (
    <Form onSubmit={handleSubmit(handleSubmitForm)}>
      <Grid padded>
        <Grid.Row>
          <Grid.Column>
            <Header as="h3">Grocery search check</Header>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column computer={2} tablet={4} mobile={16}>
            <Field
              name="query"
              label="Search"
              type="text"
              component={TextInput}
              placeholder="Search query"
            />
          </Grid.Column>
          <Grid.Column computer={2} tablet={4} mobile={16}>
            <Field
              name="tpnb"
              label="TPNB"
              type="text"
              component={TextInput}
              placeholder="TPNB"
            />
          </Grid.Column>
          <Grid.Column computer={2} tablet={4} mobile={16}>
            <Field
              name="id"
              label="Store ID (optional)"
              type="text"
              component={TextInput}
              placeholder="Store ID"
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <Button
              type="submit"
              positive
              size="small"
              disabled={submitting}
              loading={loading}
            >
              Submit
            </Button>
          </Grid.Column>
        </Grid.Row>
        {searchMessage.visible && (
          <Grid.Row>
            <Message color={searchMessage.color} onDismiss={handleDismiss}>
              <Message.Header>{searchMessage.header}</Message.Header>
              <Message.Content>{searchMessage.content}</Message.Content>
            </Message>
          </Grid.Row>
        )}
      </Grid>
    </Form>
  );
};

const validate = (values) => {
  const errors = {};

  if (!values.query) {
    errors.query = "Please enter a search term";
  }

  if (!values.tpnb) {
    errors.tpnb = "Please enter a TPNB";
  }

  return errors;
};

SearchForm = reduxForm({
  validate,
  form: "searchForm",
})(SearchForm);

export default SearchForm;
